import { useQuery } from '@tanstack/react-query';

import { DIMENSION_LIST } from '@src/emp-3.0/utils/constants';
import {
  validateGlobalFilterByDimensions,
  validatePresetByDimensions,
} from '@src/emp-3.0/utils/customDimension';

import { getDimensionList, getSuggestList } from './query';

const useGetDimensionsList = () => {
  return useQuery([DIMENSION_LIST], async () => {
    const res = await getDimensionList();
    validateGlobalFilterByDimensions(res?.data?.data);
    validatePresetByDimensions(res?.data?.data);
    return res?.data;
  });
};
const useGetSuggestData = (dimension_name: string, keyword: string, limit?: number) => {
  return useQuery(
    ['useGetSuggestData', dimension_name, keyword, limit],
    async () => {
      const res = await getSuggestList(dimension_name, keyword, limit);
      return res?.data;
    },
    {
      refetchOnMount: false,
      enabled: !!(dimension_name && keyword),
    },
  );
};

export { useGetSuggestData, useGetDimensionsList };
